//单服务暴露的接口,注册到全局，供其他服务调用
export default {
  
}